import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { ArrowRight, Mail } from 'lucide-react';

export const CTASection = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="bg-gradient-to-r from-cyan-600 to-teal-600 rounded-2xl p-12 md:p-16 text-center text-white">
        <div className="inline-block mb-4 px-4 py-1 bg-white/20 rounded-full text-sm font-semibold">
          ✓ Early Access Now Open
        </div>

        <h2 className="text-4xl md:text-5xl font-bold mb-4">
          Your AI department is ready when you are.
        </h2>

        <p className="text-2xl opacity-95 font-semibold mb-6 max-w-2xl mx-auto">
          We're building for leaders who refuse to compromise between speed and compliance.
        </p>

        <p className="text-lg opacity-90 max-w-2xl mx-auto mb-8">
          We're onboarding teams in small cohorts so every workspace gets a guided setup — your
          data, your bots, your approval gates. A department's workload, directed by your people at
          every decision gate.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <a href="mailto:support@playanoedu.com">
            <Button
              size="lg"
              className="bg-white text-cyan-600 hover:bg-slate-100 px-8 gap-2 font-semibold"
            >
              <Mail className="w-4 h-4" /> Request Access
            </Button>
          </a>
          <Link to="/about">
            <Button
              size="lg"
              variant="outline"
              className="border-white text-white hover:bg-white/10 px-8 gap-2"
            >
              How It Works <ArrowRight className="w-4 h-4" />
            </Button>
          </Link>
        </div>

        <p className="text-sm opacity-75">
          Tell us about your goals. We'll set up your workspace.
        </p>
      </div>
    </div>
  );
};
